import { _toFixed } from './util/Util'

class StartupLoading {
  private timestamps: number[] = []

  constructor() {
    this.timestamps.push(window.PMK_HEADER_LOAD || 0)
  }

  tick = () => {
    this.timestamps.push(performance.now())
    return this.timestamps.length <= 1 ? 0 :
      _toFixed((this.timestamps[this.timestamps.length - 1] - this.timestamps[this.timestamps.length - 2]) / 1000, 1)
  }

  summary = () => {
    return this.timestamps.map((t) => _toFixed(t / 1000, 1))
  }

  get lastTime() {
    return this.timestamps[this.timestamps.length - 1]
  }
}

export default new StartupLoading()
